module.exports = __webpack_public_path__ + "static/media/welcome-to-dong.0f4b3166.png";